import { Routes , Route , useNavigate } from 'react-router-dom';
import { Login } from "./components/index";
import { Home } from "./containers/index";
import {useEffect} from "react";

export default function App () {
    const navigate = useNavigate();
    useEffect(() => {
        const User = localStorage.getItem('user') == null ? localStorage.clear() : JSON.parse(localStorage.getItem('user'))
        if (!User) navigate('/login',{ replace: true });
    },[]);
    return (
        <div className="App">
            <Routes>
                <Route path="/login" element={<Login />} />
                <Route path="/*" element={<Home />} />
            </Routes>
        </div>
    )
};